import { AuthEndpoints } from './auth.endpoints';
import { UserEndpoints } from './user.endpoints';
import { CatalogEndpoints } from './catalog.endpoints';
import { TransactionEndpoints } from './transaction.endpoints';
import { ReportingEndpoints } from './reporting.endpoints';

export const EndPoints = {
  ...AuthEndpoints,
  ...UserEndpoints,
  ...CatalogEndpoints,
  ...TransactionEndpoints,
  ...ReportingEndpoints,
} as const;

export type EndPointKey = keyof typeof EndPoints;
